import { CommonModule, isPlatformBrowser } from '@angular/common';
import { 
  Component, 
  Inject,
  OnInit,
  PLATFORM_ID,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { HeaderUserComponent } from './components/header-user/header-user.component';
import { HeaderAdminComponent } from './components/header-admin/header-admin.component';
import { RegistrationComponent } from './components/authetication/registration/registration.component';
import { SessionStorageService } from './services/session-storage.service';
import { Observable, filter } from 'rxjs';
import { map } from 'rxjs/operators';
import { MiniCartComponent } from './components/cart/mini-cart/mini-cart.component';
import { UiService } from './services/ui.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { NotificationService } from './services/notification.service';
import { QuickViewComponent } from './shop/components/quick-view/quick-view.component';
import { AuthModalComponent } from './components/ui/auth-modal/auth-modal.component';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    RouterModule,
    HomeComponent,
    ProductListComponent,
    HeaderUserComponent,
    HeaderAdminComponent,
    RegistrationComponent,
    MiniCartComponent,
    QuickViewComponent,
    AuthModalComponent,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'frontend';
  isAdmin$: Observable<boolean>;
  isLoggedIn$: Observable<boolean>;

  constructor(
    private sessionStorage: SessionStorageService,
    public uiService: UiService,
    private swUpdate: SwUpdate,
    private notificationService: NotificationService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isLoggedIn$ = this.sessionStorage.watchLoggedIn();
    this.isAdmin$ = this.isLoggedIn$.pipe(
      map((loggedIn) => {
        if (loggedIn) {
          const token = this.sessionStorage.getItem('token');
          return token && token.type === 'ADMIN';
        }
        return false;
      }),
    );
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.checkForUpdates();
    }
  }

  private checkForUpdates(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          filter(
            (evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY',
          ),
        )
        .subscribe(() => {
          this.notificationService
            .confirm(
              'Actualización Disponible',
              'Hay una nueva versión de la aplicación. ¿Desea actualizar ahora?',
              'info',
            )
            .then((result) => {
              if (result.isConfirmed) {
                this.swUpdate
                  .activateUpdate()
                  .then(() => document.location.reload());
              }
            });
        });
    }
  }
}
